import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.tienePermiso
    ? _c(
        "div",
        { staticClass: "min-w-0 w-full" },
        [
          _c(
            VCard,
            { attrs: { "justify-center": "" } },
            [
              _c("state-component", {
                attrs: {
                  state: "empty_state",
                  title: "Falta Autorización",
                  subtitle: "Falta asignar autorización a su organización.",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.maintenance
    ? _c(
        "div",
        { staticClass: "min-w-0 w-full" },
        [
          _c(
            VCard,
            { attrs: { "justify-center": "" } },
            [
              _c("state-component", {
                attrs: {
                  state: "empty_state",
                  title: "En mantenimiento",
                  subtitle:
                    "Se están realizando algunas actualizaciones en el reporte.",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "min-w-0 w-full" },
        [
          _c("div", { staticClass: "display-1" }, [
            _vm._v(" " + _vm._s(_vm.titulo) + " "),
          ]),
          _vm._t("default"),
          _c(
            "actions-component",
            { attrs: { class_table: _vm.getClassTable } },
            [
              _c("template", { slot: "description" }, [
                _vm._v(" " + _vm._s(_vm.$t("log_power_bi.subtitle")) + " "),
              ]),
            ],
            2
          ),
          _c(
            VCard,
            { staticClass: "mt-1", attrs: { width: "100%", height: "110%" } },
            [
              _vm.showDashboard
                ? _c("iframe", {
                    staticStyle: { border: "0" },
                    attrs: {
                      frameborder: "0",
                      allowfullscreen: "",
                      width: "100%",
                      height: "100%",
                      src: _vm.dashboardUrl,
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "d-flex justify-center" },
                    [
                      _c(VHover, {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var hover = ref.hover
                              return [
                                _c(
                                  VCard,
                                  {
                                    class:
                                      "vertical-center alert-inca rounded-xl " +
                                      (hover ? "hover-alert" : ""),
                                  },
                                  [
                                    _c(VCardText, { staticClass: "p-0" }, [
                                      _c(
                                        "div",
                                        { staticClass: "header-alert primary" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vertical-center circle1",
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  staticClass:
                                                    "vertical-center",
                                                  attrs: { color: "white" },
                                                },
                                                [_vm._v("mdi-lock")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "header-body p-4 text-center",
                                        },
                                        [
                                          _c("p", { staticClass: "pb-0" }, [
                                            _vm._v(
                                              'Estamos realizando validaciones de seguridad. Por favor, haga click en "Copiar código" para continuar.'
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                VBtn,
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    dense: "",
                                                    rounded: "",
                                                    small: "",
                                                  },
                                                  on: { click: _vm.onCopyCode },
                                                },
                                                [_vm._v(" Copiar Código ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
            ]
          ),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }